import React, { Component } from 'react'
import i18n from 'i18next'
import ReactDOMServer from 'react-dom/server'
import * as R from 'ramda'
import { observer } from 'mobx-react'

@observer
class Certificate extends Component {
    constructor(props) {
        super(props)

        this.iframeRef = React.createRef()

        this.state = {
            loading: true,
        }
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate() {
        this.injectContentIntoIframe()
    }

    init = async () => {
        const { certificationStore } = this.props
        const { getKpiData } = certificationStore

        await getKpiData()

        this.setState({
            loading: false,
        })
        this.injectContentIntoIframe()
    }

    starRating = (rating) => {
        const stars = Array.from({ length: 5 }, (_, index) => {
            const fillPercentage = Math.min(Math.max(rating - index, 0), 1) * 100
            return (
                <div key={index} className="star-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                    <i className="far fa-star" style={{ color: '#00A19A', fontSize: '35px' }} />
                    <i
                        className="fa-solid fa-star"
                        style={{
                            color: '#00A19A',
                            fontSize: '35px',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: `${fillPercentage}%`,
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                        }}
                    />
                </div>
            )
        })
        return <div style={{ display: 'flex', gap: '10px' }}>{stars}</div>
    };

    showSatisfaction = () => {
        const { certificationStore } = this.props
        const { os } = certificationStore

        return (
            <div style={{
                borderRadius: '77px', backgroundColor: '#CADAE180', width: '272px', height: '94px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',
            }}
            >
                <div style={{ color: '#2B3C4499', fontSize: '18px', margin: '-9px 0 5px -64px' }}>{i18n.t('certification.certificate.showSatisfaction')}</div>
                {this.starRating(os)}
            </div>
        )
    }

    showScoreLabel = (score) => {
        if (score >= 75) return i18n.t('certification.certificate.excellent')
        if (score >= 60) return i18n.t('certification.certificate.veryGood')
        if (score >= 40) return i18n.t('certification.certificate.good')

        return ''
    }

    showScore = () => {
        const { certificationStore } = this.props
        const { oss } = certificationStore
        return (
            <div style={{
                borderRadius: '77px', backgroundColor: '#CADAE180', width: '272px', height: '94px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 5px',
            }}
            >
                <div style={{ marginLeft: '20px' }}>
                    <div style={{ color: '#2B3C4499', fontSize: '18px' }}>{i18n.t('certification.certificate.showScore')}</div>
                    <span style={{ fontWeight: 500, fontSize: '28px', color: '#2B3C44' }}>{this.showScoreLabel(oss)}</span>
                </div>
                <div style={{
                    backgroundColor: '#00A19A', width: '80px', height: '80px', borderRadius: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 600, fontSize: '33px',
                }}
                >
                    {Math.round(oss)}
                </div>
            </div>
        )
    }

    NPS = () => {
        const { certificationStore } = this.props
        const { nps } = certificationStore
        return (
            <div style={{
                borderRadius: '77px', backgroundColor: '#CADAE180', width: '272px', height: '94px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 5px',
            }}
            >
                <div style={{ marginLeft: '40px' }}>
                    <span style={{ fontWeight: 500, fontSize: '34px', color: '#2B3C44' }}>{i18n.t('powerpoint.options.kpi.nps')}</span>
                </div>
                <div style={{
                    backgroundColor: '#00A19A', width: '80px', height: '80px', borderRadius: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 600, fontSize: '33px',
                }}
                >
                    {nps > 0 ? '+' : ''}
                    {Math.round(nps)}
                </div>
            </div>
        )
    }

    centerComponents = () => {
        const { loading } = this.state
        const { certificationStore } = this.props
        const {
            includedKpis, oss, os, nps,
        } = certificationStore
        const showOSS = includedKpis.get('OSS') && oss && oss > 40
        const showOS = includedKpis.get('OS') && os
        const showNPS = includedKpis.get('NPS') && nps

        return !loading ? (
            <div style={{ display: 'flex', gap: '15px' }}>
                {showOS ? this.showSatisfaction() : null}
                {showOSS ? this.showScore() : null}
                {showNPS ? this.NPS() : null}
            </div>
        ) : null
    }

    eventNameFontSize = (eventName) => {
        const { length } = eventName
        if (length <= 19) {
            return 68
        }
        if (length <= 26) {
            return 48
        }
        if (length <= 35) {
            return 32
        }

        return 28
    }

    iFrameBody = () => {
        const { certificationStore } = this.props
        const eventName = R.pathOr('', ['store', 'survey', 'metadata', 'productInfo', 'industrySpecificInfo', 'productName'], certificationStore)
        const fontSize = this.eventNameFontSize(eventName)
        const { startDate, endDate } = R.pathOr({}, ['store', 'survey', 'metadata', 'productInfo', 'industrySpecificInfo'], certificationStore)
        const sDate = new Date(startDate)
        const eDate = new Date(endDate)
        const startMonth = sDate.getMonth() !== eDate.getMonth() ? sDate.toLocaleString('en-GB', { month: 'long' }) : ''

        const dateString = `${sDate.toLocaleString('en-GB', { day: '2-digit' })} ${startMonth} - ${eDate.toLocaleString('en-GB', { day: '2-digit' })} ${eDate.toLocaleString('en-GB', { month: 'long' })} ${new Date(endDate).getFullYear()}`

        return (
            <div style={{ width: '1080px', height: '1080px', backgroundColor: '#F3F8FA' }}>
                <div style={{ position: 'absolute', top: 25, left: 26 }}>
                    <svg width="1028" height="1030" viewBox="0 0 1028 1030" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M0 0V240.193H23.5291V789.807H0V1030H1028V789.807H1004.47V240.193H1028V0H0ZM1018.78 799.699V1020.11H628.858V1004.76H1004.47V799.699H1018.78ZM1004.47 230.303V25.2383H628.858V9.89196H1018.78V230.301H1004.47V230.303ZM619.634 25.2383V35.1303H995.249V994.87H619.634V1020.11H408.366V994.87H32.7511V35.1303H408.366V9.89196H619.634V25.2383ZM399.146 25.2383H23.5291V230.301H9.22203V9.89196H399.144V25.2383H399.146ZM23.5291 799.699V1004.76H399.144V1020.11H9.22203V799.699H23.5291Z" fill="#CADAE1" />
                    </svg>
                </div>
                <div style={{ width: '100%', height: '100%' }}>
                    <div style={{
                        width: '100%', display: 'flex', justifyContent: 'center', paddingTop: 50,
                    }}
                    >
                        <img src={`${process.env.CDN_URL}/images/certificationBadge.png`} alt="certification badge" />
                    </div>
                    <div style={{
                        width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
                    }}
                    >
                        <h1 style={{
                            fontSize: '68px', color: '#2B3C44', margin: '15px 0 15px 0', fontWeight: 400, fontFamily: 'Times New Roman',
                        }}
                        >
                            {i18n.t('certification.ui.certificate.title')}
                        </h1>
                        <h3 style={{
                            color: '#00A19A', fontSize: '31px', margin: '0 0 15px 0', fontWeight: 500,
                        }}
                        >
                            {i18n.t('certification.certificate.subTitle')}
                        </h3>
                        <h4 style={{
                            fontSize: '21px', color: '#95A0A4', fontWeight: 600, margin: '0 0 15px 0',
                        }}
                        >
                            {i18n.t('certification.certificate.awardedTo')}
                        </h4>
                        <h1 style={{
                            fontWeight: 400, fontFamily: 'Georgia', fontSize: `${fontSize}px`, color: '#2B3C44', margin: '0 0 15px 0', width: '910px', wordWrap: 'break-word', textAlign: 'center',
                        }}
                        >
                            {eventName}
                        </h1>
                        <h4 style={{
                            fontSize: '21px', color: '#95A0A4', fontWeight: 600, margin: '0 0 15px 0',
                        }}
                        >
                            {dateString}
                        </h4>
                        <div style={{ height: '180px' }}>
                            {this.centerComponents()}
                        </div>
                        <div style={{
                            fontSize: '13px', fontWeight: '300', color: '#2B3C44', width: '650px', textAlign: 'center',
                        }}
                        >
                            {i18n.t('certification.certificate.tsAndCs')}
                        </div>
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', width: '75%', marginTop: '50px', fontSize: '16px', color: '#2B3C44',
                        }}
                        >
                            <div>
                                <div>
                                    <div style={{ textAlign: 'center', marginBottom: '10px', fontWeight: 500 }}>
                                        {i18n.t('certification.certificate.surveyedOn')}
                                    </div>
                                    <img crossOrigin="anonymous" src={`${process.env.CDN_URL}/images/exploriLogoBlack.png`} alt="Explori Logo" />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <div style={{ textAlign: 'center', marginBottom: '10px', fontWeight: 500 }}>
                                        {i18n.t('certification.certificate.auditedBy')}
                                    </div>
                                    <img crossOrigin="anonymous" src={`${process.env.CDN_URL}/images/allianceLogo.png`} alt="Alliance for Audited Media Logo" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    };

    iframeContent = () => `
        <html>
        <head>
        <link rel="stylesheet" href="${process.env.CDN_URL}/includes/font-awesome/fontawesome-pro-6.5.2-web+copy/css/all.min.css">
          <style>
            body { margin: 0; overflow: hidden; font-family: Arial, sans-serif; } 
            #captureDiv { 
                width: 1080px; 
                height: 1080px; 
                font-family: Trebuchet MS
            }
          </style>
        </head>
        <body>
          <div id="captureDiv">
            ${ReactDOMServer.renderToStaticMarkup(<this.iFrameBody />)}
          </div>
        </body>
        </html>
      `

  injectContentIntoIframe = () => {
      const { certificationStore } = this.props
      const iframe = this.iframeRef.current

      if (!iframe) return

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document

      iframeDoc.open()
      iframeDoc.write(this.iframeContent())
      iframeDoc.close()
      certificationStore.iFrameDoc = iframeDoc
  }

  render() {
      const { includedKpis } = this.props
      this.showOss = includedKpis.get('OSS')
      this.showOS = includedKpis.get('OS')
      this.showNPS = includedKpis.get('NPS')
      return (
          <div>
              <iframe
                  ref={this.iframeRef}
                  style={{
                      position: 'absolute',
                      left: '-9999px',
                      width: '1px',
                      height: '1px',
                      border: 'none',
                      overflow: 'hidden',
                      top: 0,
                  }}
                  title="Hidden Capture"
              />
          </div>
      )
  }
}

export default Certificate
